export default __webpack_public_path__ + "static/media/popup-icon-success.d7bb98f4.svg";